// Auth
export const LOGGED_IN = "LOGGED_IN";
export const LOGGED_OUT = "LOGGED_OUT";

// Edit profile
export const EDIT_USER = "EDIT_USER";